//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailsIcon from "../../images/icons/icon-details.svg";
import ClosedMessage from "./ClosedMessage.vue";
import NavigationIcon from "../../images/icons/icon-navigation.svg";
import dayjs from "dayjs";
import dayMap from "../lib/day-map";
import { dayjsFromTime } from "../lib/dayjs-helpers";
import Hours from "./Hours.vue";

export default {
  data: () => ({
    hours: {
      isOpen: false,
      open: false,
      close: false,
      isBeforeOpening: false,
      isAfterClosing: false,
    },
    closures: [],
  }),

  components: {
    ClosedMessage,
    DetailsIcon,
    NavigationIcon,
    Hours,
  },

  props: ["location", "closed"],

  mounted() {
    this.currentDayTimes();
  },

  methods: {
    currentDayTimes() {
      let now = dayjs();
      let key = dayMap[now.day()];

      this.hours.open = dayjsFromTime(this.getLocationHours(key, "open"));
      this.hours.close = dayjsFromTime(this.getLocationHours(key, "close"));

      if (!this.hours.close.isValid()) {
        this.hours.isOpen = false;

        return;
      }

      this.hours.isOpen = true;

      if (now.isBefore(this.hours.open)) {
        this.hours.isOpen = false;
        this.hours.isBeforeOpening = true;
      }

      if (now.isAfter(this.hours.close)) {
        this.hours.isOpen = false;
        this.hours.isAfterClosing = true;
      }
    },

    getLocationHours(day, which) {
      return this.location.meta[`hours_${day}_${which}`];
    },
  },

  computed: {
    renderedAddress() {
      return this.location.meta.address.address.replace(", USA", "");
    },

    distance() {
      if (this.location.matrix) {
        return this.location.matrix.distance.text;
      }

      return "";
    },

    mapsUrl() {
      let pattern = "https://www.google.com/maps/dir/?api=1&destination=%s";

      let value = pattern.replace(
        "%s",
        encodeURIComponent(this.renderedAddress)
      );

      return value;
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/components/Location.vue